import { CustomAppLayout } from '../../layout';

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: MIT-0
import BreadcrumbGroup from '@cloudscape-design/components/breadcrumb-group';
import React, { useEffect, useRef, useState } from 'react';
import { useRouter } from '../../router';
//import { useStore } from '../store';
import { useGlobalState } from '../../../context/GlobalStateContext';


//import { useStoreAdmin } from '../../../context/useStoreAdmin';

import { Button, Checkbox, Form, FormField, Input, SpaceBetween } from '@cloudscape-design/components';
import Header from "@cloudscape-design/components/header";
import ColorModal from '../../../../components/ColorModal';
import Favorites from '../../../../components/extras/Favorites';
import { fetchWithWatch } from '../../../../hooks/fetchWithWatch';
import { ItemStatus } from '../../../../resources/types';
import { addNotification, buildBreadcrumbItems, getCookie, getUrlVersion, setData, setLoading } from '../../../commons/functions';

export const ConfigStatusesEditPage = () => {
  //const storeAdmin = useStoreAdmin();
  const [stage, setStage] = useState("A")
  const [blinkTime, setBlinkTime] = useState(2);
  const [status, setStatus] = useState<ItemStatus | null>(null);

  const { navigate } = useRouter();
  const { menu, idAirport } = useGlobalState();

  const isFirstRender = useRef(true);
  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }
    const timer = setTimeout(() => {
      navigate('system/statuses.edit?id=0')
    }, 500);
    return () => clearTimeout(timer);
  }, [idAirport]);
  useEffect(() => {
    const handleHashChange = () => {
      const hash = window.location.hash;
      const params = new URLSearchParams(hash.split("?")[1]);
      const id = params.get("id");
      if (id)
        handleGetStatus(parseInt(id));
      else {
      }
      //handleGetEmail(id ? parseInt(id) : 0);
      //else
      //setMailTemplate(undefined);
    };

    window.addEventListener("hashchange", handleHashChange);
    // also trigger once on mount
    handleHashChange();

    return () => window.removeEventListener("hashchange", handleHashChange);
  }, []);
  useEffect(() => {

  }, []);


  const handleUpdateStatus = async () => { // Make the function async

    try {
      setLoading(true)

      let tmpStatus = { ...status!, jsonConfig: { ...status!.jsonConfig, blink: status?.jsonConfig.blink === 0 ? 0 : blinkTime } };
      const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'JWT': getCookie("JWT"),
          'x-routing': '/private/config/statuses/update',
        },
        body: JSON.stringify(tmpStatus),

      });

      if (!response.ok) {
        throw new Error(`HTTP error: ${response.status}`);
      }
      const dataWeb = await response.json();
      if (dataWeb.code == 0) {
        addNotification(dataWeb.status, 'success', setData);
        window.location.hash = "#config/statuses";
      } else {
        addNotification(dataWeb.status, 'error', setData);
      }
    } catch (error: any) {
      addNotification(`Error al contactar el servidor: ${error.message}`, 'error', setData);
    } finally {
      setLoading(false)
    }
  };
  const handleGetStatus = async (id: number) => { // Make the function async

    try {
      setLoading(true)
      const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'JWT': getCookie("JWT"),
          'x-routing': '/private/config/statuses/get',
        },
        body: JSON.stringify({ idStatus: id }),

      });

      if (!response.ok) {
        throw new Error(`HTTP error: ${response.status}`);
      }
      const dataWeb = await response.json();
      if (dataWeb.code == 0) {
        if (dataWeb.status === null) {
          navigate('config/statuses');
          return;
        }
        setStatus(dataWeb.status);
        setBlinkTime(dataWeb.status.jsonConfig.blink || 2);
      } else {
        addNotification(dataWeb.status, 'error', setData);
      }
    } catch (error: any) {
      addNotification(`Error al contactar el servidor: ${error.message}`, 'error', setData);
    } finally {
      setLoading(false)
    }
  };

  return (
    <CustomAppLayout
      toolsHide={true}
      breadcrumbs={
        <BreadcrumbGroup
          items={buildBreadcrumbItems(menu)}
          expandAriaLabel="Show path"
          ariaLabel="Breadcrumbs"
        />
      }
      content={
        <SpaceBetween size="s">
          <Header variant="h1" actions={<Favorites />}>{`Editar estado  ${status?.statusES || ""}`}</Header>
          {status && (
            <Form actions={
              <SpaceBetween size="m" direction='horizontal'>
                <Button variant="link" onClick={() => { window.location.hash = "#config/statuses"; }}>Cancelar</Button>
                <Button variant="primary" onClick={() => {
                  handleUpdateStatus();
                }}>Actualizar</Button>
              </SpaceBetween>}>

              <SpaceBetween size="m" direction='vertical'>
                <SpaceBetween size="m" direction='horizontal'>
                  <div style={{ width: 200 }}>
                    <FormField label="Estado" constraintText="Nombre del estado en español">
                      <Input value={status.statusES || ""} onChange={e => {
                        setStatus({ ...status!, statusES: e.detail.value });
                      }} />
                    </FormField>
                  </div>
                  <div style={{ width: 200 }}>
                    <FormField label="Status" constraintText="Nombre del estado en ingles">
                      <Input value={status.statusEN || ""} onChange={e => {
                        setStatus({ ...status!, statusEN: e.detail.value });
                      }} />
                    </FormField>
                  </div>
                </SpaceBetween>

                <SpaceBetween direction='horizontal' size='xs'>
                  <Checkbox checked={status.isActiveStatus === 1} onChange={e => {
                    setStatus({ ...status!, isActiveStatus: e.detail.checked ? 1 : 0 });
                  }}>Activo</Checkbox>


                  <Checkbox checked={status?.jsonConfig.blink !== 0} onChange={e => {
                    setStatus({ ...status!, jsonConfig: { ...status.jsonConfig, blink: e.detail.checked ? 1 : 0 } });
                  }}>Parpadeo</Checkbox>

                  {status.jsonConfig.blink !== 0 && (
                    <div style={{ width: 50 }}>
                      <Input placeholder="Tiempo de parpadeo (s)" value={blinkTime.toString()} onChange={e => {
                        const newBlinkTime = parseInt(e.detail.value);
                        if (!isNaN(newBlinkTime)) {
                          setBlinkTime(newBlinkTime);
                        }
                      }} />
                    </div>

                  )}
                  {status.jsonConfig.blink !== 0 && (
                    <div style={{ width: 50 }}>Segundos</div>
                  )}


                </SpaceBetween>

                <SpaceBetween direction='horizontal' size='xs'>
                  <div style={{ width: 200 }}>
                    <FormField label="TAG RMS" constraintText="ID utilizado en el sistema RMS">
                      <Input value={status.AODBTAG || ""} onChange={e => {
                        setStatus({ ...status!, AODBTAG: e.detail.value });
                      }} />
                    </FormField>
                  </div>


                  <div style={{ width: 200 }}>
                    <FormField label="Diseño" constraintText="Colores desplegados en los estados">


                      <SpaceBetween direction='horizontal' size='xs'>


                        <FormField label={<small>Fondo</small>}>
                          <ColorModal
                            text=""
                            color={status.jsonConfig.colorBackground}
                            onColorSelect={(newColor: string) => {
                              setStatus({ ...status!, jsonConfig: { ...status.jsonConfig, colorBackground: newColor } }
                              );
                            }}
                          />
                        </FormField>
                        <FormField label={<small>Texto</small>}>
                          <ColorModal
                            text=""
                            color={status.jsonConfig.colorText}
                            onColorSelect={(newColor: string) => {
                              setStatus({ ...status!, jsonConfig: { ...status.jsonConfig, colorText: newColor } }
                              );
                            }}
                          />
                        </FormField>
                      </SpaceBetween>
                    </FormField>
                  </div>

                </SpaceBetween>
              </SpaceBetween>
            </Form>
          )}
        </SpaceBetween>
      }
    />
  )
};
